/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import {
    m11ReportContainerFoiChanged, m11ReportContainerResourceChanged, m11ReportSection01FoiChanged,
    m11ReportSection01ResourceChanged, selectM11ReportContainerFoi, selectM11ReportContainerResource,
    selectM11ReportSection01Foi, selectM11ReportSection01Resource, selectM11ResearchStudyResource
} from "../../slices/m11ReportAuthoringTool/m11ReportAuthoringToolSlice";
import { useEffect, useState, useImperativeHandle, forwardRef } from "react";
import jsonEquals from "../../functions/jsonEquals";
import getIdFromReference from "../../functions/getIdFromReference";
import loadResource from "../m11ReportFunctions/loadResource";
import TextDivEntry from "./TextDivEntry";
import saveM11Changes from "../../functions/saveM11ChangesAPI";
import { selectM11ResearchStudyFoi } from "../../slices/m11StepCount/m11StepCountSlice";
import { validateStep } from "../../functions/validateM11ReportAPI";

const saveObjectivesAndEstimandsChanges = async (dispatch, apiToken, m11ResearchStudyFoi,
    section111State, setAlertModalState, setStartingSection111State) => {

    let changesStates = {
        section111State: section111State
    };
    let response = await saveM11Changes(apiToken, 15, m11ResearchStudyFoi, changesStates);
    if (response?.success) {
        if (response.m11ReportContainerResource) {
            dispatch(m11ReportContainerResourceChanged(response.m11ReportContainerResource));
        }
        if (response.m11ReportSection01Resource) {
            dispatch(m11ReportSection01ResourceChanged(response.m11ReportSection01Resource));
        }
        setStartingSection111State(JSON.parse(JSON.stringify(section111State)));
    } else {
        if (response.error) {
            alert(response.error);
        }
    }
};

const M11Step015ProtocolSynopsisObjectives = forwardRef(({ theM11ResearchStudyFoi, setAlertModalState }, ref) => {

    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const m11ResearchStudyResource = useSelector(selectM11ResearchStudyResource);
    const m11ReportContainerFoi = useSelector(selectM11ReportContainerFoi);
    const m11ReportContainerResource = useSelector(selectM11ReportContainerResource);
    const m11ReportSection01Foi = useSelector(selectM11ReportSection01Foi);
    const m11ReportSection01Resource = useSelector(selectM11ReportSection01Resource);
    const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

    const [section111State, setSection111State] = useState({
        "status": "empty", "section111Xhtml": ""
    });
    const [startingSection111State, setStartingSection111State] = useState({
        "status": "empty", "section111Xhtml": ""
    });

    const [initialCalculationNeeded, setInitialCalculationNeeded] = useState(false);
    useImperativeHandle(ref, () => ({
        unsavedChanges: (m11ResearchStudyResource && !jsonEquals(section111State, startingSection111State)),
        async saveAllChanges() {
            await saveObjectivesAndEstimandsChanges(dispatch, apiToken, m11ResearchStudyFoi,
                section111State, setAlertModalState, setStartingSection111State);
        }
    }));

    useEffect(() => {
        if (m11ResearchStudyResource?.id) {
            let m11ReportFoi = "";
            if (m11ResearchStudyResource.relatesTo?.length > 0) {
                for (let relatesTo of m11ResearchStudyResource.relatesTo) {
                    if (relatesTo.type?.coding?.[0]?.code === "supported-with" && relatesTo.type.text === "M11 Report" &&
                        relatesTo.targetReference) {
                        m11ReportFoi = getIdFromReference(relatesTo.targetReference);
                    }
                }
            }
            if (m11ReportFoi && !isNaN(m11ReportFoi) && m11ReportFoi !== m11ReportContainerFoi) {
                dispatch(m11ReportContainerFoiChanged(m11ReportFoi));
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ResearchStudyResource]);

    useEffect(() => {
        if (initialCalculationNeeded === true) {
            if (Array.isArray(m11ResearchStudyResource.objective)) {
                let section111Xhtml = "<div xmlns=\"http://www.w3.org/1999/xhtml\">";
                for (const objective of m11ResearchStudyResource.objective) {
                    if (objective.type?.coding?.[0]?.display === "Primary" || objective.type?.coding?.[0]?.display === "Secondary") {
                        section111Xhtml += "<p><strong>" + objective.type.coding[0].display + " objective: " + objective.name + "</strong></p>";
                        if (objective.description) {
                            section111Xhtml += "<p>" + objective.description + "</p>";
                        }
                        section111Xhtml += "<p>This objective will be evaluated with the following outcome measures:</p>";
                        if (objective.outcomeMeasure?.length > 0) {
                            section111Xhtml += "<ul>";
                            for (const outcomeMeasure of objective.outcomeMeasure) {
                                section111Xhtml += "<li>" +
                                    (outcomeMeasure.name ? outcomeMeasure.name : outcomeMeasure.endpoint?.display) +
                                    ": " +
                                    (outcomeMeasure.description ? outcomeMeasure.description : outcomeMeasure.endpoint?.display) +
                                    "</li>";
                            }
                            section111Xhtml += "</ul>";
                        } else {
                            section111Xhtml += "<p>NO OUTCOME MEASURES LISTED.</p>";
                        }

                    }
                }
                section111Xhtml += "</div>";
                setSection111State({
                    "status": "generated", "section111Xhtml": section111Xhtml, "loaded": true
                });
                setStartingSection111State({
                    "status": "generated", "section111Xhtml": section111Xhtml, "loaded": true
                });
            } else {
                alert("Please enter at least one objective in Step 5.");
            }
        }
    }, [initialCalculationNeeded]);

    useEffect(() => {
        if (m11ReportContainerFoi && !isNaN(m11ReportContainerFoi)) {
            loadResource(m11ReportContainerFoi, "M11ReportContainer", apiToken, dispatch);
        }
    }, [m11ReportContainerFoi]);

    useEffect(() => {
        if (m11ReportContainerResource && Object.keys(m11ReportContainerResource).length > 0) {
            if (m11ReportContainerResource.section?.[1]?.entry?.length) {
                let theFoi = getIdFromReference(m11ReportContainerResource.section[1].entry[0]);
                if (theFoi && !isNaN(theFoi) && theFoi !== m11ReportSection01Foi) {
                    dispatch(m11ReportSection01FoiChanged(theFoi));
                } else {
                    setInitialCalculationNeeded(true);
                }
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportContainerResource]);

    useEffect(() => {
        if (m11ReportSection01Foi && !isNaN(m11ReportSection01Foi)) {
            loadResource(m11ReportSection01Foi, "M11ReportSection01", apiToken, dispatch);
        }
    }, [m11ReportSection01Foi]);

    useEffect(() => {
        if (m11ReportSection01Resource && Object.keys(m11ReportSection01Resource).length > 0) {
            if (m11ReportSection01Resource.section?.[0]?.section?.[0]?.section?.[0]?.text?.div &&
                m11ReportSection01Resource.section[0].section[0].section[0].text.status !== "empty") {
                let startingData = {
                    "status": m11ReportSection01Resource.section[0].section[0].section[0].text.status,
                    "section111Xhtml": m11ReportSection01Resource.section[0].section[0].section[0].text.div,
                    "loaded": true
                };
                setSection111State(startingData);
                setStartingSection111State(startingData);
            } else {
                setInitialCalculationNeeded(true);
            }
        }
    }, [m11ReportSection01Resource]);


    return <div>
        <h3>Review Primary and Secondary Objectives and Estimands Synopsis</h3>
        {!(m11ReportSection01Resource?.id || m11ReportContainerResource?.id) &&
            <h1 style={{ color: "red" }}>Please complete Step 5 (Complete Title Page) before filling in M11 Report Section details.</h1>
        }
        {section111State.loaded && <>
            {section111State.section111Xhtml ?
                <>
                    <h4 style={{ marginBottom: "0px" }}>Revise the Section 1.1.1 Primary and Secondary Objectives summary as needed.</h4>
                    <TextDivEntry elementName="section111Xhtml"
                        startingValue={section111State.section111Xhtml}
                        setResourceState={setSection111State} />
                </>
                :
                <div>
                    <p>Something is wrong.</p>
                </div>
            }
        </>}
    </div >
});

const M11Step015ProtocolSynopsisObjectivesHelperText = <div>
    <h3>Review Primary and Secondary Objectives and Estimands Synopsis</h3>
    <div style={{ textAlign: "left" }}>
        <p>Review the auto-generated summary from previously submitted data. This will be the content for Section 1.1.1 Primary and Secondary Objectives and Estimands.</p>
        <p>Revise content as desired.</p>
        <div style={{ marginLeft: "24px" }}>
            <p>Summarise the primary and secondary objectives and any associated estimands in natural, nontechnical (layperson) language.</p>
            <p>For trials intended to estimate a treatment effect or test a hypothesis related to a treatment effect, include the primary and secondary objectives and any associated estimands using a nontechnical summary describing the objective and treatment effect of interest (estimand).</p>
            <p>For other types of trials not intended to estimate a treatment effect or test a hypothesis related to a treatment effect, define trial objectives and describe additional information relevant to the clinical question(s) of interest (e.g., the endpoint(s) associated with each objective).</p>
            <p>For trials with numerous objectives in which the description of objectives will exceed half a page, consider including the most important objectives and estimands in the synopsis and refer to Section 3 Trial Objectives and Associated Estimands, which covers the objectives and estimands in technical detail. For considerations on estimands, refer to ICH E9(R1).</p>
        </div>
        <p>Click the 'Save All Changes' button.</p>
    </div>
</div>

// eslint-disable-next-line no-empty-pattern
const M11Step015ProtocolSynopsisObjectivesValidationCheck = ({ }) => {

  const apiToken = useSelector(selectCurrentUserApiToken);
  const m11ResearchStudyFoi = useSelector(selectM11ResearchStudyFoi);

  const [validationCheckState, setValidationCheckState] = useState({});

  useEffect(() => {
    if (m11ResearchStudyFoi) {
      validateStep(apiToken, 15, m11ResearchStudyFoi,
        setValidationCheckState)
    }
  }, [m11ResearchStudyFoi]);

  return <div>{validationCheckState?.success && <div>
        <h4>Step 15 (Review Primary and Secondary Objectives and Estimands Synopsis) {validationCheckState.step15numberOfChecks} issues checked. {validationCheckState.step15numberPassed} passed. {validationCheckState.step15numberFailed} failed.</h4>
        <p>Section 1.1.1 heading is 'Primary and Secondary Objectives and Estimands': {validationCheckState.resultCheckSection111Heading}</p>
        <p>Section 1.1.1 has content: {validationCheckState.resultCheckSection111Content}</p>
    </div>}  </div>
}

export default M11Step015ProtocolSynopsisObjectives;
export { M11Step015ProtocolSynopsisObjectivesHelperText, M11Step015ProtocolSynopsisObjectivesValidationCheck };